var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "deepmerge", "./Button", "./Controlbar", "./MarkupEditPanel", "./Tools", "./viewer"], function (require, exports, deepmerge_1, Button_1, Controlbar_1, MarkupEditPanel_1, Tools_1, viewer_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MarkupsGuiExtension = void 0;
    deepmerge_1 = __importDefault(deepmerge_1);
    const DefaultOptions = {
        showNameInput: true,
        showSaveButton: true,
        tools: Tools_1.DefaultTools
    };
    class MarkupsGuiExtension extends Autodesk.Viewing.Extension {
        /**
         * Constructor
         * @param viewer
         * @param options
         */
        constructor(viewer, options) {
            const opts = options ? deepmerge_1.default(DefaultOptions, options) : DefaultOptions;
            super(viewer, opts);
            this.viewer = viewer;
            this._options = opts;
            this._toolbar = new Autodesk.Viewing.UI.ToolBar('MarkupsGuiToolbar', { alignVertically: true });
            this._markupsActivated = false;
            this._buttons = [];
            this._tools = (opts === null || opts === void 0 ? void 0 : opts.tools) ? opts === null || opts === void 0 ? void 0 : opts.tools : Tools_1.DefaultTools;
            this._changesDisabled = false;
        }
        /**
         * Register and load the extension
         * @param viewer
         * @param options
         * @return Promise returning the extension
         */
        static register(viewer, options) {
            Autodesk.Viewing.theExtensionManager.registerExtension(MarkupsGuiExtension.ExtensionID, MarkupsGuiExtension);
            return viewer.loadExtension(MarkupsGuiExtension.ExtensionID, options);
        }
        load() {
            console.log('MarkupsGuiExtension is now loaded!');
            return true;
        }
        unload() {
            console.log('MarkupsGuiExtension is now unloaded!');
            // Clean our UI elements if we added any
            // if (this._group) {
            //     if (this._buttons) {
            //         let group = this._group;
            //         Object.values(this._buttons).forEach(btnElement => {
            //             group.removeControl(btnElement);
            //         });
            //     }
            //     if (this._group.getNumberOfControls() === 0) {
            //         this.viewer.toolbar.removeControl(this._group);
            //     }
            // }
            return true;
        }
        getMarkupsExtension() {
            return __awaiter(this, void 0, void 0, function* () {
                return yield viewer_1.getExtension(this.viewer, MarkupsGuiExtension.CoreExtensionID);
            });
        }
        deactivateTools(force = false) {
            return __awaiter(this, void 0, void 0, function* () {
                const ext = yield this.getMarkupsExtension();
                if (ext && (this._markupsActivated || force)) {
                    ext.hide();
                    // ext.
                    ext.unloadMarkupsAllLayers();
                    this._markupsActivated = false;
                    this.destroyControlbar();
                    this.toggleTools([]);
                    if (this.options.changeHandler) {
                        this.options.changeHandler(null, null, null);
                    }
                }
                else {
                    console.warn('Autodesk.Viewing.MarkupsCore extensions is not loaded');
                }
            });
        }
        activateTool(toolDef) {
            return __awaiter(this, void 0, void 0, function* () {
                const ext = yield this.getMarkupsExtension();
                if (ext && !this._markupsActivated) {
                    this._markupsActivated = true;
                    // todo only when not set yet
                    yield this.createControlbar();
                    ext.unloadMarkupsAllLayers();
                    ext.enterEditMode();
                }
                else if (!ext) {
                    console.warn('Autodesk.Viewing.MarkupsCore extensions is not loaded');
                }
            });
        }
        initButton(toolDef) {
            return __awaiter(this, void 0, void 0, function* () {
                const button = Button_1.createButton(toolDef, this, yield this.getMarkupsExtension());
                this._buttons.push(button);
                return button;
            });
        }
        toggleTools(activatedTools) {
            this._buttons.forEach((btn) => {
                if (activatedTools.some((toolCode) => toolCode.startsWith(btn.getId()))) {
                    btn.setState(Autodesk.Viewing.UI.Button.State.ACTIVE);
                }
                else {
                    btn.setState(Autodesk.Viewing.UI.Button.State.INACTIVE);
                }
            });
        }
        onToolbarCreated() {
            return __awaiter(this, void 0, void 0, function* () {
                // group
                const group = new Autodesk.Viewing.UI.ControlGroup('MarkupsGuiToolbarGroup');
                this._toolbar.addControl(group);
                this._buttons = [];
                for (const tool of this._tools) {
                    group.addControl(yield this.initButton(tool));
                }
                this.viewer.container.appendChild(this._toolbar.container);
                this.getMarkupsExtension().then((ext) => __awaiter(this, void 0, void 0, function* () {
                    // create style panel
                    this._markupEditPanel = new MarkupEditPanel_1.MarkupsEditPanel(this.viewer, this, ext);
                }));
            });
        }
        destroyControlbar() {
            if (this._controlBar) {
                this.viewer.container.removeChild(this._controlBar.container);
            }
            delete this._controlBar;
        }
        getNameInput() {
            var _a;
            return (_a = this._controlBar) === null || _a === void 0 ? void 0 : _a.getNameInput();
        }
        showMarkup(markupContent, viewerState, name) {
            return __awaiter(this, void 0, void 0, function* () {
                this._changesDisabled = true;
                const extension = yield this.getMarkupsExtension();
                this.deactivateTools();
                extension.unloadMarkupsAllLayers();
                // extension.clear();
                // this._markupsActivated = false;
                extension.enterEditMode(); // weird enter, but is not working without it
                extension.leaveEditMode(); // Very important!!
                this.viewer.restoreState(viewerState, undefined, true);
                extension.loadMarkups(markupContent, `Layer-${name}`);
                this._changesDisabled = false;
            });
        }
        createControlbar() {
            return __awaiter(this, void 0, void 0, function* () {
                this._controlBar = new Controlbar_1.Controlbar(this.viewer, this, yield this.getMarkupsExtension());
            });
        }
        getData(deactivateTools = false) {
            return __awaiter(this, void 0, void 0, function* () {
                const ext = yield this.getMarkupsExtension();
                const data = ext.generateData();
                const viewerState = this.viewer.getState();
                let name;
                if (this.options.showNameInput) {
                    const nameInput = this.getNameInput();
                    name = nameInput === null || nameInput === void 0 ? void 0 : nameInput.getValue();
                }
                if (deactivateTools) {
                    this.deactivateTools();
                }
                return {
                    data,
                    name,
                    viewerState,
                };
            });
        }
        changesDisabled() {
            return this._changesDisabled;
        }
        markupsActivated() {
            return this._markupsActivated;
        }
        setOptions(options) {
            this.options = deepmerge_1.default(this.options, options);
            this.syncOptions();
        }
        syncOptions() {
            var _a;
            (_a = this._controlBar) === null || _a === void 0 ? void 0 : _a.syncOptions();
        }
    }
    exports.MarkupsGuiExtension = MarkupsGuiExtension;
    /**
     * Markups core extension identifier
     */
    MarkupsGuiExtension.CoreExtensionID = 'Autodesk.Viewing.MarkupsCore';
    /**
     * Extension identifier
     */
    MarkupsGuiExtension.ExtensionID = 'IoLabs.Viewer.Extensions.MarkupsGui';
});
//# sourceMappingURL=MarkupsGuiExtension.js.map